import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function WithdrawPage() {
  const [balance, setBalance] = useState(0);
  const [cryptoBank, setCryptoBank] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [staffWhatsapp, setStaffWhatsapp] = useState(null);
  const [amount, setAmount] = useState("");
  const [user, setUser] = useState(null);
  const [processingAmount, setProcessingAmount] = useState(0);
  const [fee, setFee] = useState(0);

  // Ambil data user yang login
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        setUser(parsed);
        fetchUserData(parsed.username);
        fetchStaffWhatsapp(parsed.username);
        fetchProcessingAmount(parsed.username);
      } catch (err) {
        console.error("Gagal parse user JSON:", err);
      }
    }
  }, []);

  // Ambil balance, crypto, dan wallet dari database
  const fetchUserData = async (username) => {
    try {
      const res = await fetch("https://api.backofficemain.com/get_user_info.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username }),
      });
      const data = await res.json();
      if (data.success && data.user) {
        setBalance(data.user.balance || 0);
        setWalletAddress(data.user.wallet_code || "");
        setCryptoBank(data.user.crypto_bank_name || "");
      }
    } catch (error) {
      console.error("Gagal ambil data user:", error);
    }
  };

  // Ambil total withdrawal yang belum diapprove
  const fetchProcessingAmount = async (username) => {
  try {
    const res = await fetch("https://api.backofficemain.com/get_processing_withdrawals.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username }),
    });
    const data = await res.json();

    if (data.success) {
      const total = parseFloat(data.total) || 0;
      setProcessingAmount(total);
      setFee(total * 0.08); // 8%
    }
  } catch (error) {
    console.error("Gagal ambil processing amount:", error);
  }
};

  // Ambil WhatsApp staff berdasarkan referral
  const fetchStaffWhatsapp = async (username) => {
    try {
      const res = await fetch("https://api.backofficemain.com/get_staff_whatsapp.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username }),
      });
      const data = await res.json();
      if (data.success && data.whatsapp) {
        setStaffWhatsapp(data.whatsapp);
      }
    } catch (error) {
      console.error("Failed to retrieve WhatsApp staff:", error);
    }
  };

  // Tombol Withdraw
  const handleWithdraw = () => {
    if (!amount || parseFloat(amount) <= 0) {
      alert("Enter a valid withdrawal amount.");
      return;
    }

    if (parseFloat(amount) > parseFloat(balance)) {
      alert("Your balance is insufficient to make this withdrawal.");
      return;
    }

    if (!walletAddress) {
      alert("Enter the wallet address first.");
      return;
    }

    if (!cryptoBank) {
      alert("Cryptocurrency is not filled yet.");
      return;
    }

    if (!staffWhatsapp) {
      alert("WhatsApp staff not found for your referral.");
      return;
    }

    const message = encodeURIComponent(
      `Hello, I would like to make a withdrawal of $${amount}.`
    );
    window.open(`${staffWhatsapp}?text=${message}`, "_blank");
  };

  // Hitung fee 8%
  const withdrawalFee = amount ? (parseFloat(processingAmount) * 0.08).toFixed(2) : 0;

  return (
    <div className="container mt-5">
      <div className="card shadow-lg p-4">
        <h3 className="text-center fw-bold mb-4">
          Withdraw Your Earnings
        </h3>

        {/* Balance */}
        <div className="text-center mb-3">
          <h6 className="text-muted">Available Balance</h6>
          <h1 className="fw-bold text-white bg-danger d-inline-block px-4 py-2 rounded">
            ${parseFloat(balance).toLocaleString("en-US", { minimumFractionDigits: 2 })}
          </h1>
        </div>

        {/* Informasi Fee & Processing */}
        <div className="text-center mb-4">
          <p className="text-success mb-1">
            Withdrawal Fees (8%): ${fee.toFixed(2)}
          </p>
          <p className="text-success mb-1">
            Minimum withdrawal amount: $10
          </p>
          <p className="text-dark fw-bold">
            Current processing amount: ${processingAmount.toFixed(2)}
          </p>
        </div>

        {/* Amount Input */}
        <div className="mb-3">
          <label className="form-label">Withdraw Amount ($)</label>
          <input
            type="text"
            className="form-control"
            value={amount}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*$/.test(val)) setAmount(val.replace(/^0+/, "") || "");
            }}
            placeholder="Enter the withdrawal amount"
          />
        </div>

        {/* Cryptocurrency */}
        <div className="mb-3">
          <label className="form-label">Cryptocurrency</label>
          <input
            type="text"
            className="form-control"
            value={cryptoBank}
            readOnly
            placeholder="Nama Crypto Bank"
          />
        </div>

        {/* Wallet Address */}
        <div className="mb-3">
          <label className="form-label">Wallet Address</label>
          <input
            type="text"
            className="form-control"
            value={walletAddress}
            readOnly
            placeholder="Wallet address Anda"
          />
        </div>

        <p className="text-center text-muted">
          You can update your wallet at{" "}
          <a href="/viewpersonal" className="text-decoration-none fw-bold text-danger">
            My Account
          </a>
        </p>

        {/* Button */}
        <div className="text-center mt-4">
          <button className="btn btn-success px-4 py-2" onClick={handleWithdraw}>
            💸 Withdraw Now
          </button>
        </div>
      </div>
    </div>
  );
}
